import React, { useEffect, useRef, useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'

import { IsEmptyString } from "./GeneralFunctions";
import { SigninApiGetToken } from "../ExternalApi/SigninApi"

import CloudCTIPng from '../Assets/SignIn/CloudCTI.png'
import ColigoPng from '../Assets/SignIn/Coligo.png'
import SummaPng from '../Assets/SignIn/Summa.png'
import BOnlinePng from '../Assets/SignIn/BOnline.png'
import VoxonePng from '../Assets/SignIn/Voxone.png'
import UserPng from '../Assets/SignIn/User.png'
import PasswordPng from '../Assets/SignIn/Password.png'
import PasswordEyePng from '../Assets/SignIn/PasswordEye.png'

import "../css/Signin.css"

//Subclasses

const Signin = (props) => {

  const [mError, SetError] = useState("")
  const [mUser, SetUser] = useState("")
  const [mPassword, SetPassword] = useState("")
  const [mPasswordInputType, SetPasswordInputType] = useState("password")
  const [mBroadcastChannelSignIn, SetBroadcastChannel] = useState(new BroadcastChannel("cloudctiwebclient2024_signin"))

  mBroadcastChannelSignIn.addEventListener("message", function(event) {
    console.log("mBroadcastChannelSignIn event", event)
    
    if (event.data === "signinmessage") 
    {
      window.location.href = props.RedirectUrl
    }
  });

  const PasswordKeyDown = (evt) => {
    if ((evt.key === "Enter") && !IsEmptyString(mUser) && !IsEmptyString(mPassword)) 
    {
      SignIn()
    }
  }

  const SignIn = async () => {

    SetError("")
    const result = await SigninApiGetToken(mUser,mPassword,props.SigninMethod)
    if (result === null)
    {
        SetError("Signin failed")
    }
    else if (result.SecurityToken)
    {
        localStorage.setItem("securitytoken", result.SecurityToken)
        mBroadcastChannelSignIn.postMessage("signinmessage") // Tell other tabs to load the redirect url as well, signs them in
        window.location.href = props.RedirectUrl
    }
    else if (result.Exception)
    {
        SetError("Signin failed: " + result.Exception)
    }
  }

  return (
    <table align="center" valign="top" style={{ width: '90%' }}>        
    <tbody>
      <tr>
        <td align="center" style={{ paddingTop: '10px' }}>
        <div className="signinform">    
            <img src={props.ProductName === "Enreach Connect" ? ColigoPng : (props.ProductName === "Contact" ? SummaPng : (props.ProductName === "BOnline" ? BOnlinePng : (props.ProductName === "Voxone" ? VoxonePng : CloudCTIPng)))}/><br clear="all"/>
            <br/>
            <h4>Sign In</h4>
            {!IsEmptyString(mError) ? <div style={{ color: 'red'}}>{mError}</div> : <span/>}
            <hr/>
            <table width="100%" cellPadding="2" cellSpacing="2">
                <tbody>
                    <tr>
                        <td width="30"><img src={UserPng}/></td>
                        <td width="*"><input type="text" placeholder="Email / Phone" value={mUser} onChange={(evt) => SetUser(evt.target.value)} className="signintextbox"/></td>
                        <td width="24"/>
                    </tr>
                    <tr>
                        <td><img src={PasswordPng}/></td>
                        <td><input type={mPasswordInputType} placeholder={props.SigninMethod == "bonline" ? "Login PIN" : "Password"} value={mPassword} onChange={(evt) => SetPassword(evt.target.value)} onKeyDown={PasswordKeyDown} className="signintextbox"/></td>
                        <td><img src={PasswordEyePng} onMouseOver={() => SetPasswordInputType("text")} onMouseLeave={() => SetPasswordInputType("password")}/></td>
                    </tr>
                </tbody>
            </table>
            <br/>
            <Button variant="primary" onClick={() => SignIn()}>Sign In</Button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  ); 
}

Signin.propTypes = {
    ProductName: PropTypes.string,
    SigninMethod: PropTypes.string,
    RedirectUrl: PropTypes.string //The link to open after writing in the localStorage: its own link without onetime params 
}

export default Signin;